import { useTranslation } from 'react-i18next';
import Sparkline from './Sparkline';
import { formatValue, deltaTone } from '../lib/metrics';

const STATUS_COLOR = { ok: 'var(--ok)', warn: 'var(--warn)', crit: 'var(--crit)' };

// Tek metrik kartı: etiket + büyük değer + trend rozeti + sparkline.
export default function MetricCard({ metric, lang = 'tr' }) {
  const { t } = useTranslation();
  const { type, value, unit, betterWhen, delta7d, spark, status, baseline } = metric;
  const d = deltaTone(delta7d, betterWhen);
  const sc = STATUS_COLOR[status] || 'var(--ok)';

  return (
    <div className="metric-card" style={status && status !== 'ok' ? { borderColor: sc } : undefined}>
      <div className="mc-head">
        <span className="mc-label">
          <span className="mc-dot" style={{ background: sc }} />
          {t(`metric.${type}`, type)}
        </span>
        <span className={`mc-delta ${d.tone}`}>{d.text}</span>
      </div>
      <div className="mc-value">{formatValue(value, unit, lang)}</div>
      <div className="mc-spark">
        <Sparkline data={spark || []} color={sc === 'var(--ok)' ? 'var(--accent)' : sc} />
      </div>
      {baseline != null && (
        <div className="mc-foot">{t('dash.baseline')}: {formatValue(baseline, unit, lang)}</div>
      )}
    </div>
  );
}
